
import Konva from 'konva/lib/Core'
import * as _ from 'lodash';
import Vue from 'vue';
export default class Schema {
  constructor(num = 0, w = 950, h = 1170) {
    this.initialSize = {
      w: w,
      h: h
    }
    this.stage = null
    this.selection = []
    this.schemaLayers = []
    this.selectionData = {
      hasSelection: false
    }
    this.tableauData = null
    this.selectAction = null
    this.lastNum = num
    this.currentLayer = null
    this.layerList = []
    this.linkedData = []
    this.expandedNodes = []
    this.shapeDataLinks = []
    this.espaces = []
  }

  moveNodeTo(layer) {
    const _this = this
    function changeLayer(node, layer) {
      const matrix = node.getAbsoluteTransform().getMatrix()
      const attrs = _this.decompose(matrix)
      node.setAttr('draggable', true)
      node.moveTo(layer)
      node.setAttrs(attrs)
    }

    if (layer === this.currentLayer) {
      return
    }

    const parent = this.selection[0].getParent()

    this.selection.forEach(e => {
      changeLayer(e, layer)
      if (e.getAttr('anchors')) {
        e.getAttr('anchors').forEach(anchor => {
          anchor.moveTo(layer)
        })
      }
    })

    if (this.shapeDataLinks.length) {
      this.shapeDataLinks.forEach(e => {
        changeLayer(e, layer)
      })
    }

    if (parent.getType() === 'Group' && !parent.hasName('selectionGroup')) {
      changeLayer(parent, layer)
      this.selection.forEach(el => {
        el.setAttr('draggable', false)
        parent.add(el)
      })
    }
    this.clearSelection()
    this.updateLayerTree()
    this.refresh()
  }

  addLinkedData(idTableau, key, rowNo) {
    this.linkedData.push({ idTableau, key, rowNo })
  }

  getAllLayer() {
    return this.stage.getChildren().toArray().map(el => el)
  }

  findNode(_id) {
    return this.stage.findOne(node => {
      return _id === node._id
    })
  }

  toggleAction(nodeId, isExpanded) {
    if (isExpanded) {
      this.expandedNodes.push(nodeId)
    } else {
      const index = this.expandedNodes.indexOf(nodeId)
      if (nodeId >= 0) {
        this.expandedNodes.splice(index, 1)
      }
    }
  }

  deleteNode(node, isLayer = false) {
    if (isLayer) {
      const defaultLayer = this.stage.getChildren()
        .toArray()
        .find(el => {
          return el.getAttr('isDefault') === true
        })
      node.getChildren().toArray().forEach(e => {
        const matrix = e.getAbsoluteTransform().getMatrix()
        const attrs = this.decompose(matrix)
        e.setAttr('draggable', true)
        e.moveTo(defaultLayer)
        e.setAttrs(attrs)
      })
      node.destroy()
      this.refresh()
    } else {
      const { shapeType: type } = node.getAttrs()
      if (type === 'rect' || type === 'circle') {
        this.findLink(node).forEach(el => {
          el.destroy()
        })
        this.findAnchor(node).forEach(el => {
          el.destroy()
        })
      }
      const layer = node.getLayer()
      node.destroy()
      this.clearSelector()
      this.stage.find('Transformer').destroy()
      layer.draw()
    }
    this.updateLayerTree()
  }

  _border = "1px solid #2b3085"
  // initiResizer(pos1, pos1Value, pos2, pos2Value) {
  //   const resizer = document.createElement('div')
  //   resizer.style.position = "absolute";
  //   resizer.style.zIndex = 100;
  //   resizer.style[pos1] = pos1Value;
  //   resizer.style[pos2] = pos2Value;
  //   resizer.style.cursor = 'cursor';
  //   resizer.style.borderLeft = this._border;
  //   resizer.style.borderRight = this._border;
  //   resizer.style.borderRadius = '3px'
  //   return resizer
  // }

  initStage() {
    this.stage = new Konva.Stage({
      height: this.initialSize.h,
      width: this.initialSize.w,
      container: 'canvas'
    })
    Vue.prototype.$stage = {
      height: this.initialSize.h,
      width: this.initialSize.w,
    }
    const konvaContainer = document.getElementsByClassName('konvajs-content')
    const canvas = document.getElementById('canvas')


    setTimeout(() => {
      if (konvaContainer.length) {
        // Désactivation du "resize" pour les schémas fonctionels
        // const cvas = konvaContainer[0]
        const can = document.getElementsByTagName('canvas')[0]
        // const topSideResizer = this.initiResizer('top', '-10px', 'left', 'calc(49% - 12.5px)')
        // topSideResizer.style.top = "-25px"
        // topSideResizer.style.borderTop = this._border;
        // topSideResizer.style.paddingLeft = '15px'
        // topSideResizer.style.paddingRight = '15px'
        // topSideResizer.innerHTML = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-angle-up fa-w-10"><path fill="currentColor" d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z" class=""></path></svg>`
        // cvas.appendChild(topSideResizer)

        // const rightSideResizer = this.initiResizer('top', 'calc(49% - 10px)', 'right', '-10px')
        // rightSideResizer.style.right = "-20px"
        // rightSideResizer.style.borderTop = this._border;
        // rightSideResizer.style.borderBottom = this._border;
        // rightSideResizer.style.borderLeft = 'none';
        // rightSideResizer.style.padding = '5px'
        // rightSideResizer.innerHTML = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-angle-right fa-w-8"><path fill="currentColor" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" class=""></path></svg>`
        // cvas.appendChild(rightSideResizer)
        //
        // const bottomSideResizer = this.initiResizer('bottom', '-10px', 'left', 'calc(49% - 12.5px)')
        // bottomSideResizer.style.bottom = "-25px"
        // bottomSideResizer.style.borderBottom = this._border;
        // bottomSideResizer.style.paddingLeft = '15px'
        // bottomSideResizer.style.paddingRight = '15px'
        // bottomSideResizer.innerHTML = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-angle-down fa-w-10"><path  fill="currentColor" d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z" class=""></path></svg>`
        // cvas.appendChild(bottomSideResizer)
        //
        // const leftSideResizer = this.initiResizer('top', 'calc(49% - 10px)', 'left', '-10px')
        // leftSideResizer.style.left = "-20px"
        // leftSideResizer.style.borderTop = this._border;
        // leftSideResizer.style.borderBottom = this._border;
        // leftSideResizer.style.borderRight = 'none';
        // leftSideResizer.style.padding = '5px'
        // leftSideResizer.innerHTML = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa fa-angle-left fa-w-8"><path fill="currentColor" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z" class=""></path></svg>`
        // cvas.appendChild(leftSideResizer)

        let dragging = false
        let offset = [0, 0]
        let pageLeft = 0
        /** Left Resizer */
        const mousedownX = (e, type, mousemove, mouseup) => {
          e.preventDefault()
          dragging = true
          const clientOffset = can.style[type].replace('px', '')
          if (clientOffset !== "")
            pageLeft = +clientOffset;
          Vue.prototype.$stage.width = this.stage.width();
          offset = [e.clientX, e.clientY]
          canvas.addEventListener('mousemove', mousemove, false)
          canvas.addEventListener('mouseup', (e) => mouseup(e, mousemove, mouseup), false)
        }

        const leftMouseMove = (e) => {
          e.preventDefault()
          if (dragging) {
            let left = e.clientX - offset[0]
            const width = Vue.prototype.$stage.width - left
            this.stage.width(width)
            can.style.left = pageLeft + left + 'px'
          }
        }
        const mouseupX = (e, mousemove, mouseup) => {
          e.preventDefault()
          dragging = false
          offset = [0, 0]
          Vue.prototype.$stage.width = this.stage.width();
          canvas.removeEventListener('mousemove', mousemove, false)
          canvas.removeEventListener('mouseup', (e) => mouseup(e, mousemove, mouseup), false)
        }
        leftSideResizer.addEventListener(
          'mousedown',
          (e) => mousedownX(e, 'left', leftMouseMove, mouseupX),
          false
        )

        /** Right Resizer */
        let pageRight = 0
        const rightMouseMove = (e) => {
          e.preventDefault()
          if (dragging) {
            const movedRight = e.clientX - offset[0]
            const width = Vue.prototype.$stage.width + movedRight
            can.style.right = (pageRight - movedRight) + 'px'
            this.stage.width(width)
          }
        }

        rightSideResizer.addEventListener(
          'mousedown',
          (e) => mousedownX(e, 'right', rightMouseMove, mouseupX),
          false
        )

        /** Top Resizer */
        const topMouseMove = (e) => {
          e.preventDefault()
          if (dragging) {
            const movedTop = e.clientY - offset[1]
            const height = Vue.prototype.$stage.height - movedTop
            this.stage.height(height)
          }
        }
        const mousedownY = (e, mousemove, mouseup) => {
          e.preventDefault()
          offset = [e.clientX, e.clientY]
          dragging = true
          Vue.prototype.$stage.height = this.stage.height()
          canvas.addEventListener('mousemove', mousemove, false)
          canvas.addEventListener('mouseup', (e) => mouseup(e, mousemove), false)
        }
        const mouseupY = (e, mousemove, mouseup) => {
          e.preventDefault()
          offset = [0, 0]
          dragging = false
          Vue.prototype.$stage.height = this.stage.height()
          canvas.removeEventListener('mousemove', mousemove, false)
          canvas.removeEventListener('mouseup', (e) => mouseup(e, mousemove, mouseup), false)
        }
        topSideResizer.addEventListener(
          'mousedown',
          (e) => mousedownY(e, topMouseMove, mouseupY),
          false)

        /** Bottom Resizer */
        const bottomMouseMove = (e) => {
          e.preventDefault()
          const moved = offset[1] - e.clientY
          const height = Vue.prototype.$stage.height - moved
          this.stage.height(height)
        }

        bottomSideResizer.addEventListener(
          'mousedown',
          (e) => mousedownY(e, bottomMouseMove, mouseupY),
          false)
      }
    }, 500);
  }

  updateNodeName(node, name) {
    const fnode = this.findNode(node.data._id)
    if (fnode) {
      fnode.name(name)
      this.updateLayerTree()
    }
  }

  getTableauData(idTableau, key, rowNo) {
    const tableau = this.tableauData.find(el => el.id + '' === idTableau + '')
    const keyIndex = tableau.columns.findIndex(col => col.key === key)
    const data = tableau.data[rowNo][keyIndex]
    let res = {
      title: tableau.data[0][keyIndex],
      data: data,
      unit: tableau.columns[keyIndex].unit
    }
    if (('' + data).startsWith('=')) {
      if (tableau.formulaValue && data && ('' + data).startsWith('=')) {
        const jexcel = require('jexcel')
        const colName = jexcel.getColumnNameFromId([keyIndex, rowNo])
        // eslint-disable-next-line no-eval
        res.data = isNaN(tableau.formulaValue[colName]) ? Math.round(eval(data.split('=')[1])) : tableau.formulaValue[colName]
      }
    }
    return res
  }

  setStyle(type, value) {
    switch (type) {
      case 'STROKE_SIZE':
        if (this.selection.length) {
          this.selection.forEach(el => {
            if (value <= 2) {
              el.strokeWidth(value)
              el.hitStrokeWidth(3)
            } else {
              el.strokeWidth(value)
              el.hitStrokeWidth('auto')
            }
          })
          this.refresh()
        }
        break
      case 'STROKE_COLOR':
        if (this.selection.length) {
          this.selection.forEach((el, index, arr) => {
            el.stroke(value)
            if (index === (arr.length - 1)) {
              this.formatSelectionData(el)
            }
          })
          this.refresh()
        }
        break
      case 'SHAPE_FILL':
        if (this.selection.length) {
          this.selection.forEach((el, index, arr) => {
            el.fill(value)
            if (index === (arr.length - 1)) {
              this.formatSelectionData(el)
            }
          })
          this.refresh()
        }
        break
      case 'LINE_TYPE':
        const [, , linecap] = [...arguments]
        if (this.selection.length) {
          this.selection.forEach((el, index, arr) => {
            el.dash(value)
            el.lineCap(linecap)
            if (index === (arr.length - 1)) {
              this.formatSelectionData(el)
            }
          })
          this.refresh()
        }
        break
    }
  }

  setTextStyle(type, value) {
    switch (type) {
      case 'FONT_SIZE':
        if (this.selection.length) {
          this.selection.forEach(el => {
            el.fontSize(value)
          })
          this.refresh()
        }
        break
      case 'FONT_FAMILY':
        if (this.selection.length) {
          this.selection.forEach(el => {
            el.fontFamily(value)
          })
          this.refresh()
        }
        break
      case 'FONT_STYLE':
        if (this.selection.length) {
          this.selection.forEach(el => {
            el.fontStyle(value)
          })
          this.refresh()
        }
        break
      case 'FONT_COLOR':
        if (this.selection.length) {
          this.selection.forEach(el => {
            el.fill(value)
          })
          this.refresh()
        }
        break
      case 'SHOW_TITLE':
        if (this.selection.length) {
          this.selection.forEach(el => {
            if (el.getAttr('shapeType') === 'text') {
              const { idTableau, key, rowNo } = el.getAttrs()
              const tdata = this.getTableauData(idTableau, key, rowNo)
              const text = value ? `${ tdata.title }: ${ tdata.data } ${ tdata.unit ? tdata.unit : '' }` : `${ tdata.data } ${ tdata.unit ? tdata.unit : '' }`
              el.text(text)
              el.setAttr('showTitle', value)
            }
          })
          this.refresh()
        }
        break
    }
  }

  setOpacity(value) {
    if (this.selection.length) {
      if (this.selection[0].getClassName() === 'Layer') {
        this.selection[0].opacity(value)
        this.selection[0].batchDraw()
      } else {
        this.selection.forEach(el => {
          el.opacity(value)
        })
        this.refresh(true)
      }
    }
  }

  formatSelectionData(node = null) {
    let newVal = null
    if (node) {
      if (node.getClassName() === 'Layer') {
        newVal = {
          hasSelection: true,
          opacity: node.opacity(),
          currentType: 'layer'
        }
      }
      else if (node.getClassName() === 'Group') {
        return
      } else {
        newVal = {
          hasSelection: true,
          opacity: node.opacity(),
          currentStyle: {
            stroke: node.getAttr('stroke'),
            strokeWidth: node.getAttr('strokeWidth'),
            fill: node.getAttr('fill'),
            dash: node.dash()
          },
          currentType: node.getAttr('shapeType')
        }
        if (newVal.currentType === 'text' || newVal.currentType === 'customText') {
          newVal = {
            ...newVal,
            fontFamily: node.getAttr('fontFamily'),
            fontSize: node.getAttr('fontSize'),
            fontStyle: node.getAttr('fontStyle'),
            showTitle: node.getAttr('showTitle') || false
          }
        }
      }
    } else {
      newVal = {
        hasSelection: false
      }
    }
    this.selectionData = newVal
  }

  clearSelector() {
    this.stage.find('.selector')
      .toArray()
      .forEach(el => {
        el.destroy()
      })
  }

  showAttachAnchors(value) {
    this.stage.find('.attach')
      .toArray()
      .forEach(el => {
        el.visible(value)
      })
  }

  getShapeEdges(shape) {
    function rotatePoint(origin, coord, rad) {
      const rcos = Math.cos(rad)
      const rsin = Math.sin(rad)
      return {
        x: (coord.x - origin.x) * rcos - (coord.y - origin.y) * rsin + origin.x,
        y: (coord.x - origin.x) * rsin + (coord.y - origin.y) * rcos + origin.y
      }
    }

    const transform = this.stage.getAbsoluteTransform().copy()
    transform.invert()
    let newAttrs, type
    type = shape.getClassName()
    if (type === 'Rect') {
      // const matrix = shape.getAbsoluteTransform().getMatrix()
      const matrix = transform.multiply(shape.getAbsoluteTransform()).getMatrix()
      newAttrs = {
        ...shape.getAttrs(),
        ...this.decompose(matrix)
      }
    } else {
      newAttrs = shape.getClientRect({ relativeTo: this.stage })
    }

    const { x, y, width, height, scaleX = 1, scaleY = 1, rotation = 0 } = newAttrs
    const uwidth = width * scaleX
    const uheight = height * scaleY
    const angle = Konva.getAngle(rotation)

    if (type === 'Circle') {
      const TOPCENTER = rotatePoint({ x, y }, { x: x + (uwidth / 2), y }, angle)
      const RIGHTCENTER = rotatePoint({ x, y }, { x: x + uwidth, y: y + (uheight / 2) }, angle)
      const BOTTOMCENTER = rotatePoint({ x, y }, { x: x + (uwidth / 2), y: y + uheight }, angle)
      const LEFTCENTER = rotatePoint({ x, y }, { x: x, y: y + (uheight / 2) }, angle)
      return { topCenter: TOPCENTER, rightCenter: RIGHTCENTER, bottomCenter: BOTTOMCENTER, leftCenter: LEFTCENTER }
    } else {
      const TOPLEFT = { x, y }
      const BOTTOMLEFT = rotatePoint({ x, y }, { x: x, y: y + uheight }, angle)
      const TOPRIGHT = rotatePoint({ x, y }, { x: x + uwidth, y }, angle)
      const BOTTOMRIGHT = rotatePoint({ x, y }, { x: x + uwidth, y: y + uheight }, angle)
      const TOPCENTER = rotatePoint({ x, y }, { x: x + (uwidth / 2), y }, angle)
      const RIGHTCENTER = rotatePoint({ x, y }, { x: x + uwidth, y: y + (uheight / 2) }, angle)
      const BOTTOMCENTER = rotatePoint({ x, y }, { x: x + (uwidth / 2), y: y + uheight }, angle)
      const LEFTCENTER = rotatePoint({ x, y }, { x: x, y: y + (uheight / 2) }, angle)
      return {
        topLeft: TOPLEFT,
        bottomLeft: BOTTOMLEFT,
        topRight: TOPRIGHT,
        bottomRight: BOTTOMRIGHT,
        topCenter: TOPCENTER,
        rightCenter: RIGHTCENTER,
        bottomCenter: BOTTOMCENTER,
        leftCenter: LEFTCENTER
      }
    }
  }

  updateAnchors(node) {
    const newValues = this.getShapeEdges(node)

    const zindex = node.zIndex()

    node.getAttr('anchors').forEach(anchor => {
      const coord = newValues[anchor.getAttr('location')]
      anchor.x(coord.x)
      anchor.y(coord.y)
      anchor.zIndex(zindex + 1)
    })
    return newValues
  }

  updateConnectors(node, anchors) {
    const _this = this
    function getNodeAttrs(node, type) {
      const transform = _this.stage.getAbsoluteTransform().copy()
      transform.invert()
      const matrix = transform.multiply(node.getAbsoluteTransform()).getMatrix()
      const attrs = _this.decompose(matrix)
      switch (type) {
        case 'rect':
        case 'circle':
        case 'line':
        case 'arrow':
        case 'doubleArrow':
        case 'dashedArrow':
        case 'doubleDashedArrow':
        case 'eye':
        case 'text':
        case 'customText':
          return {
            ...node.getAttrs(),
            ...attrs
          }
        case 'customArrow':
        case 'customDoubleArrow':
          const { width, height } = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: true,
            relativeTo: _this.stage
          })
          return {
            ...node.getAttrs(),
            ...attrs,
            width: width * attrs.scaleX,
            height: (height * attrs.scaleY) / 4
          }
      }
    }
    let edge, connectorCoord
    this.stage.find(el => {
      return el.hasName('connector') && (el.getAttr('from') || el.getAttr('to'))
    }).forEach(con => {
      if (con.getAttr('from') && con.getAttr('from').id === node.getAttr('id')) {
        const conAttrs = getNodeAttrs(con, con.getAttr('shapeType'))
        const [, , x, y] = con.getAttr('points')
        connectorCoord = {
          x: conAttrs.x,
          y: conAttrs.y
        }
        edge = anchors[con.getAttr('from').position]
        con.setAttr('points', [edge.x - connectorCoord.x, edge.y - connectorCoord.y, x, y])
      } else if (con.getAttr('to') && con.getAttr('to').id === node.getAttr('id')) {
        const conAttrs = getNodeAttrs(con, con.getAttr('shapeType'))
        const [x, y, ,] = con.getAttr('points')
        connectorCoord = {
          x: conAttrs.x,
          y: conAttrs.y
        }
        edge = anchors[con.getAttr('to').position]
        con.setAttr('points', [x, y, edge.x - connectorCoord.x, edge.y - connectorCoord.y])
      }
    })
  }
  ungroup(group) {
    let children = group.getChildren()
    const layer = group.getLayer()
    children.toArray().forEach(e => {
      const matrix = e.getAbsoluteTransform().getMatrix()
      const attrs = this.decompose(matrix)
      e.setAttr('draggable', true)
      e.moveTo(layer)
      e.setAttrs(attrs)
      if (e.id().startsWith('shape')) {
        const anchors = this.updateAnchors(e)
        this.updateConnectors(e, anchors)
        this.findLink(e).forEach(link => {
          link.moveToTop()
        })
      }
    })
    group.destroy()
  }

  clearSelection() {
    this.selection = []
    this.shapeDataLinks = []
    this.selectAction = null
    this.currentLayer = this.stage.getChildren().toArray()[0]
    this.formatSelectionData()
    this.stage.find('Transformer').destroy()
    const selectionGp = this.stage.find('.selectionGroup').toArray()
    const selectionMrk = this.stage.find('.marker').toArray()
    if (selectionGp.length) {
      this.ungroup(selectionGp[0])
    }
    if (selectionMrk.length) {
      selectionMrk.forEach(mrk => {
        mrk.destroy()
      })
    }
    this.clearSelector()
    this.showAttachAnchors(false)
  }

  select(type, node) {
    switch (type) {
      case 'group':
        this.selection = [node]
        this.currentLayer = node.getLayer()
        this.selectAction = {
          type: 'group',
          node: node
        }
        break
      case 'multiple':
        if (this.selection.length && node.getLayer() !== this.currentLayer) {
          console.log('Different layer')
          this.clearSelection()
          break // Multiselection entre différent calque impossible
        }
        this.selection = [...this.selection, node]
        this.currentLayer = node.getLayer()
        this.selectAction = {
          type: 'multiple',
          node: node
        }
        break
      case 'connector':
        this.selection = [node]
        this.currentLayer = node.getLayer()
        this.selectAction = {
          type: 'connector',
          node: node
        }
        break
      case 'shape':
      case 'eye':
        this.clearSelection()
        this.refresh()
        this.selection = [node]
        this.currentLayer = node.getLayer()
        this.formatSelectionData()
        this.selectAction = {
          type: 'shape',
          node: node
        }
        break
      case 'layer':
        this.selection = [node]
        this.currentLayer = node
        this.formatSelectionData(node)
        this.selectAction = {
          type: 'layer',
          node: node
        }
        break
    }
  }

  moveDown(node, isLayer = false) {

    if (isLayer) {
      node.moveDown();
      this.refresh();
      this.updateLayerTree()
      return;
    }
    let selectedIndex = -1

    const parent = node.getParent();
    if (parent && parent.getClassName() === 'Group') {
      selectedIndex = node.index;
      const children = parent.getChildren()
      if (selectedIndex === children.length - 1) {
        return;
      }
      const nextIndex = selectedIndex + 1;
      const nextNode = children[nextIndex]
      const lastCreatedAt = node.attrs.createdAt
      const lastZIndex = node.zIndex();
      node.setAttr('createdAt', nextNode.attrs.createdAt)
      node.zIndex(nextNode.zIndex())

      nextNode.setAttr('createdAt', lastCreatedAt)
      nextNode.zIndex(lastZIndex)
      node.getLayer().draw();
      this.updateLayerTree()
      return;
    }

    const { children } = Object.assign({ children: [] }, this.schemaLayers[0]);
    const displayShaped = {}
    let i = 0;
    for (const child of children) {
      if (child.nodeId && !child.nodeId.startsWith('dataLink')) {
        displayShaped[child.nodeId] = i
        if (node.attrs.id === child.nodeId) {
          selectedIndex = i
        }
        i++;
      }
    }

    const totalShapes = Object.keys(displayShaped)
    if (selectedIndex === totalShapes.length - 1) {
      return;
    }
    const nextIndex = selectedIndex + 1;
    const current = { linkData: {} }
    const next = { linkData: {} }
    this.stage.find(n => {
      const { id, linkTo } = n.attrs;
      if (displayShaped[id] === selectedIndex) {
        current.node = n;
      } else if (displayShaped[linkTo] === selectedIndex) {
        current.linkData[id] = n
      }
      if (displayShaped[id] === nextIndex) {
        next.node = n;
      } else if (displayShaped[linkTo] === nextIndex) {
        next.linkData[id] = n
      }
    });

    const zIndex = current.node.zIndex();
    const createdAt = current.node.attrs.createdAt;
    const nzIndex = next.node.zIndex();
    const ncreatedAt = next.node.attrs.createdAt;

    current.node.zIndex(nzIndex);
    current.node.setAttr('createdAt', ncreatedAt);
    Object.keys(current.linkData).forEach(key => {
      current.linkData[key].zIndex(nzIndex + 1);
      current.linkData[key].setAttr('createdAt', ncreatedAt - 1);
    })

    next.node.zIndex(zIndex);
    next.node.setAttr('createdAt', createdAt);
    Object.keys(next.linkData).forEach(key => {
      next.linkData[key].zIndex(zIndex + 1);
      next.linkData[key].setAttr('createdAt', createdAt - 1);
    })

    node.getLayer().draw();
    this.updateLayerTree();
  }

  moveUp(node, isLayer = false) {

    if (isLayer) {
      node.moveDown();
      this.refresh();
      this.updateLayerTree()
      return;
    }
    let selectedIndex = -1

    const parent = node.getParent();
    if (parent && parent.getClassName() === 'Group') {
      selectedIndex = node.index;
      const children = parent.getChildren()
      if (selectedIndex === children.length - 1) {
        return;
      }
      const nextIndex = selectedIndex - 1;
      const nextNode = children[nextIndex]
      const lastCreatedAt = node.attrs.createdAt
      const lastZIndex = node.zIndex();
      node.setAttr('createdAt', nextNode.attrs.createdAt)
      node.zIndex(nextNode.zIndex())

      nextNode.setAttr('createdAt', lastCreatedAt)
      nextNode.zIndex(lastZIndex)
      node.getLayer().draw();
      this.updateLayerTree()
      return;
    }

    const { children } = Object.assign({ children: [] }, this.schemaLayers[0]);
    const displayShaped = {}
    let i = 0;
    for (const child of children) {
      if (child.nodeId && !child.nodeId.startsWith('dataLink')) {
        displayShaped[child.nodeId] = i
        if (node.attrs.id === child.nodeId) {
          selectedIndex = i
        }
        i++;
      }
    }

    if (!selectedIndex) {
      return;
    }
    const nextIndex = selectedIndex - 1;
    const current = { linkData: {} }
    const next = { linkData: {} }
    this.stage.find(n => {
      const { id, linkTo } = n.attrs;
      if (displayShaped[id] === selectedIndex) {
        current.node = n;
      } else if (displayShaped[linkTo] === selectedIndex) {
        current.linkData[id] = n
      }
      if (displayShaped[id] === nextIndex) {
        next.node = n;
      } else if (displayShaped[linkTo] === nextIndex) {
        next.linkData[id] = n
      }
    });

    const zIndex = current.node.zIndex();
    const createdAt = current.node.attrs.createdAt;
    const nzIndex = next.node.zIndex();
    const ncreatedAt = next.node.attrs.createdAt;

    current.node.zIndex(nzIndex);
    current.node.setAttr('createdAt', ncreatedAt);
    Object.keys(current.linkData).forEach(key => {
      current.linkData[key].zIndex(nzIndex + 1);
      current.linkData[key].setAttr('createdAt', ncreatedAt - 1);
    })

    next.node.zIndex(zIndex);
    next.node.setAttr('createdAt', createdAt);
    Object.keys(next.linkData).forEach(key => {
      next.linkData[key].zIndex(zIndex + 1);
      next.linkData[key].setAttr('createdAt', createdAt - 1);
    })


    node.getLayer().draw();
    this.updateLayerTree();
  }

  refresh(isBatch = false) {
    if (isBatch) {
      this.stage.batchDraw()
    } else {
      this.stage.draw()
    }
  }

  addNewLayer() {
    if (this.getAllLayer().length >= 5) {
      throw new Error('Le nombre de calque maximum (5) est atteint')
    } else {
      const newLayer = new Konva.Layer({
        name: `Calque-${ this.lastNum++ }`
      })
      this.stage.add(newLayer)
      this.clearSelection()
      this.updateLayerTree()
      this.refresh()
    }
  }

  updateLayerTree() {
    const layerTree = []
    this.traverseLayers(this.stage, layerTree)
    this.schemaLayers = layerTree.map(item => {
      item.children = _.orderBy(item.children,
        ['createdAt', 'zIndex', 'createdAtIndex'],
        ['desc', 'desc', 'asc']
      )
      return item
    })
    this.layerList = this.getAllLayer()
  }

  getParentNodeName(type, node) {
    if (type === 'Layer') {
      return node.name() ? node.name() : 'Calque'
    } else {
      return node.name() ? node.name() : `Groupe-${ node._id }`
    }
  }

  traverseLayers(node, parent, espaces, parentNodeType = ['Layer', 'Group']) {
    node.getChildren().toArray().forEach((el, index) => {
      const child = { index: el.index }
      if (el.getClassName() === 'Transformer') {
        return
      }
      const type = parentNodeType.indexOf(el.getClassName()) > -1 ? el.getClassName() : el.getAttr('shapeType')
      if (type === 'Stage') {
        this.traverseLayers(el, child)
      } else if (parentNodeType.indexOf(el.getType()) > -1) {
        child.children = []

        child.title = this.getParentNodeName(type, el)
        child.isExpanded = this.expandedNodes.includes(el._id)
        child.isDraggable = false
        if (el.attrs.createdAt) {
          child.nodeId = el.attrs.id;
          child.createdAt = el.attrs.createdAt
          if (el.attrs.createdAtIndex) {
            child.createdAtIndex = el.attrs.createdAtIndex;
          }
        }
        child.data = {
          visible: true,
          type: type.toLowerCase(),
          _id: el._id
        }
        if (type === 'Layer') {
          child.data.isDefault = el.getAttr('isDefault')
          parent.push(child)
        } else {
          parent.children.push(child)
        }
        this.traverseLayers(el, child)
      } else if (type !== 'anchor' && ['selector'].indexOf(el.name()) === -1) {
        child.createdAt = el.attrs.createdAt
        child.nodeId = el.attrs.id;


        if (type === 'circle' || type === 'rect' || type === 'text') {
          let editable = true
          if (typeof el.attrs.theName !== 'undefined') {
            editable = false
          }

          child.data = {
            visible: true,
            type: 'shape',
            _id: el._id,
            editable: editable,
          }
        } else {
          child.data = {
            visible: true,
            type: 'connector',
            _id: el._id
          }
        }
        child.data.isLink = !!el.attrs.linkTo
        child.isDraggable = false

        if (typeof el.attrs.theName !== 'undefined') {
          child.title = el.attrs.theName
          if (child.title.trim() === "")
            child.title = type
        } else {
          child.title = el.name() || el.id() || type
        }
        child.isLeaf = true
        parent.children.push(child)
      }
    })
  }
  decompose(mat) {
    var a = mat[0]
    var b = mat[1]
    var c = mat[2]
    var d = mat[3]
    var e = mat[4]
    var f = mat[5]

    var delta = a * d - b * c

    let result = {
      x: e,
      y: f,
      rotation: 0,
      scaleX: 0,
      scaleY: 0,
      skewX: 0,
      skewY: 0
    }

    // Apply the QR-like decomposition.
    if (a !== 0 || b !== 0) {
      var r = Math.sqrt(a * a + b * b)
      result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r)
      result.scaleX = r
      result.scaleY = delta / r
      result.skewX = Math.atan((a * c + b * d) / (r * r))
      result.scleY = 0
    } else if (c !== 0 || d !== 0) {
      var s = Math.sqrt(c * c + d * d)
      result.rotation =
        Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s))
      result.scaleX = delta / s
      result.scaleY = s
      result.skewX = 0
      result.skewY = Math.atan((a * c + b * d) / (s * s))
    } else {
      // a = b = c = d = 0
    }

    result.rotation *= 180 / Math.PI
    return result
  }

  findLink(node) {
    const { shapeType: type, id } = node.getAttrs()
    if (type === 'rect' || type === 'circle') {
      return this.stage.find(el => {
        return el.getAttr('linkTo') + '' === id + ''
      }).toArray()
    }
  }

  findAnchor(node) {
    const { shapeType: type, id } = node.getAttrs()
    if (type === 'rect' || type === 'circle') {
      return this.stage.find(el => {
        return el.name() === 'attach' && el.getAttr('nodeId') + '' === id + ''
      }).toArray()
    }
  }

  destroy() {
    this.stage.destroy()
    this.stage = null
  }
}



// WEBPACK FOOTER //
// ./src/pages/pageSchemaFonctionnel/model/schema.js